import { render } from "./Terms2View.vue?vue&type=template&id=fc451892&scoped=true"
const script = {}

import "./Terms2View.vue?vue&type=style&index=0&id=fc451892&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc451892"]])

export default __exports__